import { render, staticRenderFns } from "./ShowMoreText.vue?vue&type=template&id=1a369b82&scoped=true&"
import script from "./ShowMoreText.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreText.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMoreText.vue?vue&type=style&index=0&id=1a369b82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a369b82",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
